import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './OrderStepsProgress.module.scss';

interface OrderStepsProgressProps {
  step: number | null;
  isError: boolean;
  isGray: boolean;
}

export const OrderStepsProgress: FC<OrderStepsProgressProps> = ({
  step,
  isError,
  isGray,
}) => {
  return (
    <div className={styles.progress}>
      <div
        className={classNames(
          styles.progress_filled,
          isError && styles.progress_error,
          isGray && styles.progress_gray,
        )}
        style={{ width: `${step ? step * 14.2857142857 : 100}%` }}
      />
    </div>
  );
};
